/* eslint-disable complexity */
import {
    toast as luffyToast,
    // ToastObject as LuffyToastObject,
    ToastItem as LuffyToastItem,
} from '@baidu/luffy-comp-toast';
import {ErrorNewSvg, SuccessNewSvg, WarningNewSvg} from '@/icons';
import Icon, {IconSize} from '@/components/Icon';

import './index.scss';

interface LuffyToastObject {
    id: string;
    remove: () => void;
}

export enum ToastType {
    Info = 'info',
    Normal = 'normal',
    Success = 'success',
    Warning = 'warning',
    Error = 'error',
}

export interface ToastProps {
    content: string | React.ReactNode;
    manualClose?: boolean;
    duration?: number;
    type?: ToastType;
    onClose?: () => void;
    id?: string;
    icon?: React.FunctionComponent;
    className?: string;
    allowMultiple?: boolean;
}

type ToastObjects = {
    [index in ToastType]?: LuffyToastObject;
};

export const toastObjects: ToastObjects = {};

interface ContentProps {
    content?: React.ReactNode;
    svg: React.FunctionComponent;
}

(window as any).removeAllKuToast = () => { // 以便数据表可以批量清除wiki-web层的toast
    Object.keys(toastObjects).forEach((key: string) => {
        const toastKey = key as ToastType;
        toastObjects[toastKey]?.remove();
        delete toastObjects[toastKey];
    });
};

function CustomContent(props: ContentProps) {
    const {svg, content} = props;
    return (
        <div className="ku-toast-custom-content">
            <Icon svg={svg} size={IconSize.LGX} className="ku-toast-custom-icon" />
            {content}
        </div>
    );
}

function BuiltInContent(props: ContentProps) {
    const {svg, content} = props;
    return (
        <div className="ku-toast-builtin-content">
            <Icon svg={svg} size={IconSize.Auto} className="ku-toast-icon" />
            {content}
        </div>
    );
}

async function toast(props: ToastProps) {
    const {content, manualClose, duration, type, icon, onClose, id, className, allowMultiple = false} = props;
    let toastContent = content;
    if (type === ToastType.Success) {
        toastContent = (<BuiltInContent content={content} svg={SuccessNewSvg} />);
    } else if (type === ToastType.Error) {
        toastContent = (<BuiltInContent content={content} svg={ErrorNewSvg} />);
    } else if (type === ToastType.Warning) {
        toastContent = (<BuiltInContent content={content} svg={WarningNewSvg} />);
    }
    if (icon) {
        toastContent = (<CustomContent content={content} svg={icon} />);
    }
    // eslint-disable-next-line @typescript-eslint/await-thenable
    const toastOptions: Partial<LuffyToastItem> = await {
        content: toastContent,
        manualClose: !!manualClose,
        onClose: onClose,
        className: className,
    };
    if (duration || duration === 0) {
        toastOptions.duration = duration;
    }
    // normal 不限制唯一提示框
    if (type && type !== ToastType.Normal) {
        toastOptions.id = id || type;
        if (!allowMultiple) {
            Object.keys(toastObjects).forEach((key: string) => {
                // console.log(key);
                if (key !== type) {
                    // console.log('remove....');
                    const toastKey = key as ToastType;
                    toastObjects[toastKey]?.remove();
                    delete toastObjects[toastKey];
                }
            });
        }
    }
    // eslint-disable-next-line @typescript-eslint/await-thenable
    const curToast = luffyToast(toastOptions);
    if (type && type !== ToastType.Normal) {
        toastObjects[type] = curToast as LuffyToastObject;
    }

    // 文档更新提示框位置调整
    // 可用css, :has()选择器实现取消父元素样式，但兼容弱，只支持safari15.4及以上和chrome。就先用js实现吧~~
    const toastNode = document.getElementsByClassName('brick-toast');
    const parentNode = toastNode[0].parentNode as HTMLElement;
    if (toastNode.length > 0) {
        if (toastNode[0].classList.contains('previewTip') || toastNode[0].classList.contains('editTip')) {
            // 取消父元素样式，方便添加定位
            parentNode.style.left = 'initial';
            parentNode.style.transform = 'initial';
        } else {
            // 改回父元素默认，防止其他toast样式偏移
            parentNode.style.left = '0';
            parentNode.style.transform = 'translate(-50%, 0)';
        }
    }

    return curToast;
}
export default toast;
